// extracted by mini-css-extract-plugin
export default {"cardBackground":"Card_cardBackground__A7K0S","cardItem":"Card_cardItem__tKsQ6","cardImg":"Card_cardImg__3mcv2","cardTitle":"Card_cardTitle__JVVgb","link":"Card_link__G6CIl"};